import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { getTzTimeStates, getTzDate } from '@ninja/utilities';
import styles from './DatePicker4.js';
import { checkIsValidRangeForYearView } from './utils6.js';
import { useCalendarViewContext } from './components10.js';

const YearsView = ({ onClick }) => {
    const { viewState: { tzDate, viewNavigate, currentCalendar, intervalStartDate, intervalEndDate }, fromDate, toDate, isIntervalPicker, maxSelectionRangeDays, } = useCalendarViewContext();
    const _a = getTzTimeStates(tzDate), { year } = _a, resetDateState = __rest(_a, ["year"]);
    const middleYear = year + viewNavigate;
    const yearsArray = [];
    const { year: hijriYear } = getTzTimeStates(tzDate, currentCalendar);
    const hijriMiddleYear = hijriYear + viewNavigate;
    const hijriYearsArray = [];
    for (let i = 1; i < 13; i++) {
        yearsArray.push(middleYear - 5 + i);
        hijriYearsArray.push(hijriMiddleYear - 5 + i);
    }
    return (jsx("div", { className: styles.monthAndYearGrid, children: yearsArray.map((year, index) => {
            const currentYearDate = getTzDate(Object.assign(Object.assign({}, resetDateState), { year }));
            const disabled = !checkIsValidRangeForYearView({
                isIntervalPicker,
                maxSelectionRangeDays,
                intervalStartDate,
                intervalEndDate,
                currentYearDate,
                toDate,
                fromDate,
                currentCalendar,
            });
            return (jsx("div", { className: styles.monthAndYearItem(disabled), onClick: () => onClick(currentYearDate), children: hijriYearsArray[index] }, year));
        }) }));
};

export { YearsView };
